import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/NameEnglisch';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalDataEnglisch';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/ContactEnglisch';
import { AdditionalConsentSubForm, Schema as AdditionalConsentSchema } from '../subforms/AdditionalConsentEnglisch';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/DocumentsEnglisch';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformationEnglisch';

export const GSKLuxEngSchema = (settings) => (
    Yup.object()
        .concat(PersonalDataSchema)
        .concat(NameSchema(settings))
        .concat(ContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(AdditionalConsentSchema)
        .concat(DocumentsSchema(settings))
);

export const GSKLuxEng = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>The fields marked with * are mandatory.</Form.Text>
            <Field component={PersonalDataSubForm} colors={colors} />
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalConsentSubForm} colors={colors} settings={settings} />
        </>
    );
}